import React from "react";
import { BulkDeleteButton, Datagrid, EditButton, List, TextField } from "react-admin";
import { SearchableList } from "../SearchableList";

export const ListComponent: React.FC = () => {
  return (
    <List perPage={100}>
      <SearchableList>
      <Datagrid
        rowClick="show"
        bulkActionButtons={<BulkDeleteButton mutationMode="optimistic" />}
        sx={{
          '& tbody tr:nth-of-type(odd)': { backgroundColor: '#1a1a1a' },
          '& tbody tr:nth-of-type(even)': { backgroundColor: '#000000' },
        }}
      >
        <TextField source="name" />
        <TextField source="email" />
        <TextField source="created_at" />
        <EditButton />
      </Datagrid>
      </SearchableList>
    </List>
  );
};
